export enum EnumVisitQuestionRuleType {
  Category = 1,
  VisitType = 2,
  AnswerEquals = 3,
  JewishOwned = 4,
}
